






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import '@/vue_material/components';

@Component({})
export default class Home extends Vue {
  private opened: boolean = false;
  private hideDialog: boolean = false;

  public open(): void {
    this.opened = true;
  }

  public get showDialog(): boolean {
    const showDialog = localStorage.getItem('showHowToUseDialog');

    return !(showDialog === 'false');
  }

  @Watch('hideDialog')
  private saveHideDialogOption(): void {
    localStorage.setItem('showHowToUseDialog', `${!this.hideDialog}`);
  }

  private openCamera(): void {
    this.$emit('onConfirmed');
  }
}
